import styled from "styled-components";
import { styled as MUIStyled } from "@mui/material/styles";
import { Rating } from "@mui/material";
import { Container } from "react-bootstrap";

export const StyledRating = MUIStyled(Rating)({
  "& .MuiRating-iconFilled": {
    color: "var(--secondary-color)",
  },
  svg: {
    fontSize: "40px",
    margin: "5px",
  },
  path: {
    color: "var(--secondary-color)",
    border: "2px solid var(--secondary-color)",
  },
});
export const StyledContainer = styled(Container)`
  width: 80%;
  @media screen and (max-width: 786px) {
    width: 100%;
  }
  h3 {
    font-weight: 400;
    font-size: var(--font-size-base);
    color: var(--blue-color-dark);
  }
  .feedback-level {
    width: 260px;
    span {
      font-weight: 400;
      font-size: var(--font-size-base);
      color: var(--blue-color-dark);
      @media screen and (max-width: 786px) {
        font-weight: 500;
        font-size: var(--font-size-lg);
      }
    }
  }
  .student-name {
    font-weight: 500;
    font-size: var(--font-size-sm);
    color: var(--field-color);
  }
  .student-message {
    font-weight: 400;
    font-size: var(--font-size-sm);
    color: var(--text-color-dark);
    overflow-wrap: break-word;
  }
`;
